<template>
	<swiper class="stories-main-slider" ref="storiesMainSlider" :slides-per-view="swiperOptions.slidesPerView"
		:centeredSlides="swiperOptions.centeredSlides" :initialSlide="swiperOptions.initialSlide"
		@swiper="onSetMainSlider" @slideChange="onSlideChange" @touchStart="onTouchStart" @touchEnd="onTouchEnd">
		<swiper-slide class="stories-main-slider__item" v-for="(story, i) in stories" :key="i"
			:style="{ backgroundColor: story.bg }" @click="slideTo(i, speed)">
			<!-- передаём индекс в обработчик события swiper -->
			<StoriesGroupSlider :mainStory="story" @swiper="onSetGroupSlider(i, $event)" @slideChange="onSlideChange" />
			<button class="close-btn stories-main-slider__item-btn" @click="closeStory">
				<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M2.63477 2.63617L15.3627 15.3641" stroke="white" stroke-width="1.1" stroke-linecap="round"/>
					<path d="M2.63477 15.364L15.3627 2.63603" stroke="white" stroke-width="1.1" stroke-linecap="round"/>
				</svg>
			</button>
		</swiper-slide>

		<div class="stories-main-slider__nav" @touchstart="onTouchStart" @touchend="onTouchEnd">
			<button class="stories-main-slider__nav-prev" v-show="!isPrevBtnHidden" @click="slidePrev">
				<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
						<path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round"></path>
					</g>
				</svg>
			</button>
			<button class="stories-main-slider__nav-next" v-show="!isNextBtnHidden" @click="slideNext">
				<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
						<path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round"></path>
					</g>
				</svg>
			</button>
		</div>

		<button class="close-btn stories-main-slider__btn" @click="closeStory">
			X
		</button>
	</swiper>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import StoriesGroupSlider from '@/components/dashboard/Stories/Group/StoriesGroupSlider.vue';
import 'swiper/css';

export default {
	components: {
		Swiper,
		SwiperSlide,
		StoriesGroupSlider
	},
	data() {
		return {
			mainSlider: null,
			groupSlider: null,
			// хранилище экземпляров group-swipers по индексу main slide
			groupSwipers: {},
			autoplayDelay: 5000,
			speed: 500,
			isPaused: false,
			intervalId: null,
			swiperOptions: {
				slidesPerView: 'auto',
				centeredSlides: true,
				initialSlide: 0
			}
		};
	},
	computed: {
		...mapState({
			stories: state => state.news.stories,
			storyIndex: state => state.news.storyIndex,
		}),

		// скрыть Prev если нет предыдущего внутреннего слайда и нет предыдущего main-слайда
		isPrevBtnHidden() {
			const activeIdx = this.mainSlider?.activeIndex ?? (typeof this.storyIndex === 'number' ? this.storyIndex : 0);
			const group = this.groupSwipers[activeIdx] ?? this.groupSlider;

			// если текущая группа есть и в ней больше одного слайда — учитываем её состояние
			if (group) {
				const slidesCount = (group.slides && group.slides.length) || 0;
				if (slidesCount > 1 && group.isBeginning === false) return false; // есть предыдущий внутренний слайд
			}

			// иначе смотрим на главный слайдер
			if (this.mainSlider) {
				// isBeginning === true -> прятать кнопку
				return !!this.mainSlider.isBeginning;
			}

			// fallback: если индекс 0 — прячем
			return activeIdx <= 0;
		},

		// скрыть Next если нет следующего внутреннего слайда и нет следующего main-слайда
		isNextBtnHidden() {
			const activeIdx = this.mainSlider?.activeIndex ?? (typeof this.storyIndex === 'number' ? this.storyIndex : 0);
			const group = this.groupSwipers[activeIdx] ?? this.groupSlider;

			if (group) {
				const slidesCount = (group.slides && group.slides.length) || 0;
				if (slidesCount > 1 && group.isEnd === false) return false; // есть следующий внутренний слайд
			}

			if (this.mainSlider) {
				return !!this.mainSlider.isEnd;
			}

			// fallback: если на последнем main — прячем
			return activeIdx >= ((this.stories && this.stories.length) ? this.stories.length - 1 : 0);
		}
	},
	methods: {
		...mapMutations({
			setStoryIndex: 'news/setStoryIndex',
			showStory: 'news/showStory'
		}),

		onSetMainSlider(swiper) {
			this.mainSlider = swiper;
			// обновляем ссылку на group для текущего слайда
			this.groupSlider = this.groupSwipers[this.mainSlider.activeIndex] ?? null;
			this.setProgress();
			const idx = this.storyIndex;
			if (typeof idx === 'number' && this.mainSlider) {
				this.mainSlider.slideTo(idx, 0);
			}
		},
		// теперь принимаем index и сам swiper
		onSetGroupSlider(index, swiper) {
			// сохраняем экземпляр по индексу
			this.$set ? this.$set(this.groupSwipers, index, swiper) : (this.groupSwipers[index] = swiper);
			// если это текущий активный слайд — обновляем ссылку
			if (this.mainSlider && index === this.mainSlider.activeIndex) {
				this.groupSlider = swiper;
			}
			this.setProgress();
		},
		setProgress() {
			// всегда берем group для текущего активного main слайда
			const activeIdx = this.mainSlider?.activeIndex ?? 0;
			const group = this.groupSwipers[activeIdx] ?? this.groupSlider;
			if (!group || !group.el) return;

			const bullets = group.el.querySelectorAll('.swiper-pagination-bullet');
			const time = this.autoplayDelay / 100;

			bullets.forEach((bullet, index) => {
				const span = bullet.querySelector('span');
				if (span) span.style.transform = 'translateX(-100%)';

				// используем локальную переменную group вместо this.groupSlider
				const activeInner = group.activeIndex ?? 0;

				if (index === activeInner) {
					let transform = -100;
					this.stopProgress();
					this.intervalId = setInterval(() => {
						if (!this.isPaused && transform < 0) transform += 1;
						if (span) span.style.transform = `translateX(${transform}%)`;

						if (group.isEnd && transform === 0) {
							this.stopProgress();
							if (this.mainSlider?.isEnd) {
								this.closeStory();
							} else {
								this.mainSlider?.slideNext(this.speed);
							}
						} else if (transform === 0) {
							group.slideNext(this.speed);
						}
					}, time);
				} else if (index < activeInner) {
					if (span) span.style.transform = `translateX(0%)`;
				}
			});
		},
		stopProgress() {
			if (this.intervalId) {
				clearInterval(this.intervalId);
				this.intervalId = null;
			}
		},
		onSlideChange() {
			// при смене активного main слайда переключаем текущую group ссылку и прогресс
			this.groupSlider = this.groupSwipers[this.mainSlider?.activeIndex] ?? null;
			if (this.mainSlider) {
				this.stopProgress();
				this.setProgress();
			}
			this.setActiveIndex();
		},
		setActiveIndex() {
			const idx = this.mainSlider?.activeIndex ?? 0;
			this.setStoryIndex(idx)
		},
		onTouchStart() {
			this.isPaused = true;
		},
		onTouchEnd() {
			this.isPaused = false;
		},
		slideNext() {
			const activeIdx = this.mainSlider?.activeIndex ?? 0;
			const sg = this.groupSwipers[activeIdx] ?? this.groupSlider;
			// если у текущей группы есть следующий внутренний слайд — перелистываем его,
			// иначе переходим к следующему main слайду
			if (sg && Array.isArray(sg.slides) ? sg.slides.length > 1 && sg.isEnd === false : (sg.slides && sg.slides.length > 1 && sg.isEnd === false)) {
				sg.slideNext(this.speed);
				return;
			}
			this.mainSlider?.slideNext();
		},
		slidePrev() {
			const activeIdx = this.mainSlider?.activeIndex ?? 0;
			const sg = this.groupSwipers[activeIdx] ?? this.groupSlider;
			if (sg?.isBeginning === false) {
				sg.slidePrev(this.speed);
				return;
			}
			this.mainSlider?.slidePrev();
		},
		slideTo(i, s = 0) {
			this.mainSlider?.slideTo(i, s);
		},
		closeStory() {
			this.stopProgress();
			this.showStory(false)
			this.setStoryIndex(null)
		}
	},
	beforeUnmount() {
		this.stopProgress();
	}
};
</script>

<style lang="scss" scoped>
.stories-main-slider {
	overflow: visible;
	width: 100%;

	&__item {
		margin: 0 10vw;
		width: 360px;
		height: 560px;
		border-radius: 1.6rem;
		transform: scale(0.6);
		transition: transform 0.3s ease;
		position: relative;
		@media only screen and  (max-width: 425px) {
			width: 300px;
			height: 550px;
		}

		&.swiper-slide-prev,
		&.swiper-slide-next {
			cursor: pointer;
		}

		&.swiper-slide-prev {
			&:hover {
				transform: scale(0.6) translate(20%);
			}
		}

		&.swiper-slide-next {
			&:hover {
				transform: scale(0.6) translate(-20%);
			}
		}

		&.swiper-slide-active {
			transform: scale(1);

			:deep(.stories-group-slider__pagination) {
				opacity: 1;
				visibility: visible;
			}

			.stories-main-slider__item-btn {
				opacity: 1;
				visibility: visible;
			}
		}

		&-btn {
			position: absolute;
			top: -48px;
			right: -48px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 48px;
			height: 48px;
			background: none;
			border: none;
			cursor: pointer;
		}
	}

	&__nav {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 32rem;
		z-index: 100;

		&-prev,
		&-next {
			padding: 0.5rem;
			width: 45px;
			height: 45px;
			background: none;
			border-radius: 100%;
			color: var(--color-white);
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			transition: background-color 0.3s ease;
			cursor: pointer;
			border: none;

			&:hover {
				color: var(--color-blue);
			}
		}

		&-prev {
			left: 0;
		}

		&-next {
			right: 0;
		}
	}

	&__btn {
		display: none;
	}
}
</style>